var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaAudio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.777,
    height: 32.702,
    viewBox: "0 0 31.777 32.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 31.777,
    height: 32.702,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1769.266,4688.915a2.616,2.616,0,0,1-.734-1.818,2.552,2.552,0,0,1,2.548-2.55,2.538,2.538,0,0,1,.922.173v-6.737a.815.815,0,0,1,.616-.789l4.538-1.133,4.142-1.037a.815.815,0,0,1,1.01.79v9.113a.807.807,0,0,1-.008.109,2.382,2.382,0,0,1-2.38,2.295,2.381,2.381,0,0,1-2.382-2.382,2.383,2.383,0,0,1,2.382-2.382,2.355,2.355,0,0,1,.761.125v-2.355l-7.052,1.823v4.936a2.625,2.625,0,0,1-.734,1.818,2.506,2.506,0,0,1-1.815.787A2.506,2.506,0,0,1-1769.266,4688.915Z",
    transform: "translate(1779 -4669)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaAudio);
export default __webpack_public_path__ + "static/media/media-audio.e67d2f6a0f98ae3546a30763c92995e8.svg";
export { ForwardRef as ReactComponent };